'use strict';
angular.module('schoolLinqApp').controller('eventController', [
	'$scope',
	'Idle',
	'$uibModal',
	'authService',
	'$uibModalStack',
	'$location',
	function ($scope, Idle, $uibModal, authService, $uibModalStack, $location) {
		$scope.events = [];

		$scope.ajsLoading = null;
		$scope.ngxLoading = true;

		const hideAJSLoading = ['/login', '/'].includes($location.path());
		$scope.ngxLoading = !hideAJSLoading;

		if (!hideAJSLoading) {
			$scope.ajsLoading = new Promise((resolve) => {
				authService.loaded$.subscribe((loaded) => {
					if (loaded) {
						resolve();
					}
					$scope.ngxLoading = false;
				});
			});
		}

		function closeModals() {
			if ($scope.warning) {
				$scope.warning.close();
				$scope.warning = null;
			}

			if ($scope.timedout) {
				$scope.timedout.close();
				$scope.timedout = null;
			}
		}

		$scope.start = function () {
			closeModals();
			Idle.watch();
			$scope.started = true;
		};

		$scope.stop = function () {
			closeModals();
			Idle.unwatch();
			$scope.started = false;
		};

		$scope.$on('IdleStart', function () {
			closeModals();

			$scope.warning = $uibModal.open({
				template: require('@ajs/templates/warning-dialog.tpl.html'),
				windowClass: 'modal-danger',
			});
		});

		$scope.$on('IdleTimeout', function () {
			closeModals();
			authService.logOut();
			//Timeout added because the Exit Without Saving was popping up slightly after dismissAll was called.
			setTimeout(function () {
				$uibModalStack.dismissAll();
				$scope.timedout = $uibModal.open({
					template: require('@ajs/templates/timedout-dialog.tpl.html'),
					windowClass: 'modal-danger',
				});
			}, 100);
		});

		$scope.$on('IdleEnd', function () {
			closeModals();
		});
	},
]);
